export enum ButtonSelectionType {
  None = 0,
  Tote = 1,
  Fob = 2,
  ToteAndFob = 3,
}
